import { of } from 'rxjs';
import { map, mergeAll, filter } from 'rxjs/operators';
import { Action } from '@banking/ui/workflows/balance';
import * as cardListWorkflow from '@banking/ui/workflows/balance/card-list';

// FIXME(steckel): Use TypeScript parameter inference once overloaded functions
// are supported (https://github.com/microsoft/TypeScript/issues/32164)
// import type RouterService from '@ember/routing/router-service';
// type TransitionToArgs = Parameters<RouterService['transitionTo']>;

const navigateToStatements = updates => updates.pipe(filter(([_, action]) => action.type === Action.Type.UserClickStatementsAndDocuments), map(([states, _]) => states[0].unitToken), map(unitToken => ['banking.statements', {
  queryParams: {
    unitToken,
    returnTo: 'balance-applet-checking'
  }
}]));
const canNavigateToAdditionalCard = state => state.allowMultipleCards;

/**
 * When a user clicks the "Add Card" button:
 *
 * - If allowMultipleCards is true (US users): Navigate to additional card flow
 *   Users don't need to go through KYB and account verification again, even if
 *   they have a deactivated card. The additional card flow also allows ordering
 *   cards for other users, which the onboarding flow doesn't support.
 *
 * - If allowMultipleCards is false (non-US users): Navigate to onboarding flow
 */
const navigateToAdditionalCard = updates => updates.pipe(filter(([[_, after], action]) => action.type === cardListWorkflow.ActionType.UserClickAddDebitCard && canNavigateToAdditionalCard(after.cardListState)), map(([states, _]) => states[0].unitToken), map(unitToken => {
  return ['banking.additional-card', {
    queryParams: {
      unitToken,
      start: 'true'
    }
  }];
}));
const navigateToOnboarding = updates => updates.pipe(filter(([[_, after], action]) => action.type === cardListWorkflow.ActionType.UserClickAddDebitCard && !canNavigateToAdditionalCard(after.cardListState)), map(([states, _]) => states[0].unitToken), map(unitToken => {
  return ['banking.checking', {
    queryParams: {
      unitToken,
      start: 'true'
    }
  }];
}));
const navigateToBillPayHomePage = updates => {
  return updates.pipe(filter(([states, action]) => action.type === Action.Type.UserClickPayBills && states[0].canSeeBillPay), map(([states, _]) => states[0].unitToken), map(unitToken => ['bill-pay-engine.bill-pay.list', {
    queryParams: {
      currentUnitToken: unitToken
    }
  }]));
};
const navigateToBillPayNewBillPage = updates => updates.pipe(filter(([states, action]) => action.type === Action.Type.UserClickUploadBill && states[0].canSeeBillPay), map(([states, _]) => states[0].unitToken), map(unitToken => ['bill-pay-engine.bill-pay.list.new', {
  queryParams: {
    currentUnitToken: unitToken
  }
}]));
const routerTransitions = source => of(...[navigateToStatements, navigateToBillPayHomePage, navigateToBillPayNewBillPage, navigateToAdditionalCard, navigateToOnboarding].map(transition => source.pipe(transition))).pipe(mergeAll());
export default routerTransitions;